// ChargeModal.tsx
import * as React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    useMediaQuery,
    useTheme,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ChargeModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const ChargeModal: React.FC<ChargeModalProps> = ({
    open,
    onClose,
    title,
    children,
    maxWidth = 'md',
}) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth
            fullScreen={fullScreen}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: fullScreen ? 0 : 2,
                    minHeight: fullScreen ? '100vh' : '60vh',
                    maxHeight: fullScreen ? '100vh' : '90vh',
                },
            }}
        >
            <DialogTitle
                sx={{
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    padding: theme.spacing(2, 3),
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography
                        variant="h6"
                        component="h2"
                        sx={{ fontWeight: 600 }}
                    >
                        {title}
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers sx={{ padding: 0 }}>
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default ChargeModal;
